import React, { useEffect, useState } from 'react';
import { Autocomplete, Divider, Button, Dialog, Grid, TextField, IconButton, Tooltip, Typography, DialogTitle, DialogContent, DialogActions, Chip, Paper, Box, Select, MenuItem, FormControl, FormControlLabel, InputLabel, Checkbox, ListItem, ListItemText } from "@mui/material";

import { Edit as EditIcon, Check as CheckIcon, Close as CloseIcon } from '@mui/icons-material';
import { withRouter } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { updateServiceLineDetails, ACTION_TYPES, getAllSitesWithDevices, getSitesForTerminal, addSiteToServiceLineApi, geocodeServiceAddress } from '../slice';
import { toast } from "react-toastify";
import _ from 'lodash';
import { getDecodeURI, strToK4List } from '../../../utils/util';

const ServiceLineDetails = (props) => {
    const { serviceLineToUpdate, updateServiceLineDetails, changeSLName, updateSLDetails, getVesselsListing, filteredVessels, location,
        getAllSitesWithDevices, siteForTerminal, sitesWithDevices, getSitesForTerminal, starlinkAdmin, addSiteToServiceLineApi, addSiteToServiceLine, geocodeServiceAddress } = props
    const dispatch = useDispatch();
    const [isEditingServiceLine, setIsEditingServiceLine] = useState(false);
    const [isEditingHomeAddress, setIsEditingHomeAddress] = useState(false);
    const [serviceLineName, setServiceLineName] = useState('');
    const [originalServiceLineName, setOriginalServiceLineName] = useState('');
    const [homeAddress, setHomeAddress] = useState('');
    const [originalHomeAddress, setOriginalHomeAddress] = useState('');
    const [emails, setEmails] = useState<any>([]);
    const [originalEmails, setOriginalEmails] = useState([]);
    const [emailInput, setEmailInput] = useState('');
    const [notes, setNotes] = useState('');
    const [originalNotes, setOriginalNotes] = useState('');
    const [error, setError] = useState('');
    const [dialogOpen, setDialogOpen] = useState(false);
    const [selectedSite, setSelectedSite] = useState("");
    const [selectedDevice, setSelectedDevice] = useState("");
    const [sites, setSites] = useState<any>([]);
    const [loader, setLoader] = useState(false)
    const [showCheck, setShowCheck] = useState(true)
    const [addressSuggestions, setAddressSuggestions] = useState<any[]>([])
    const [isFetchingSuggestions, setIsFetchingSuggestions] = useState(false)
    const [addressSearchInput, setAddressSearchInput] = useState('')
    const [mobileTerminal, setMobileTerminal] = useState<boolean>(true);
    const [originalMobileTerminal, setOriginalMobileTerminal] = useState<boolean>(true);

    const [addressData, setAddressData] = useState({
        administrativeAreaCode: ``,
        regionCode: '',
        formattedAddress: ``,
        addressLines: [],
        latitude: '',
        longitude: ''
    });

    const formFields = [
        {
            label: "Address Lines",
            placeholder: "Address lines",
            value: addressData.addressLines,
            onChange: (e) => handleAddressChange('addressLines', [e.target.value]),
            xs: 12,
        },
        {
            label: "Region Code",
            placeholder: "Region ex: US",
            value: addressData.regionCode,
            onChange: (e) => handleAddressChange('regionCode', e.target.value),
            xs: 6,
        },
        {
            label: "Administrative Area Code",
            placeholder: "State ex: CA",
            value: addressData.administrativeAreaCode,
            onChange: (e) => handleAddressChange('administrativeAreaCode', e.target.value),
            xs: 6,
        },
        {
            label: "Latitude",
            placeholder: "Auto-filled from address",
            value: addressData.latitude,
            onChange: (e) => handleAddressChange('latitude', e.target.value),
            xs: 6,
            helperText: "Auto-filled",
        },
        {
            label: "Longitude",
            placeholder: "Auto-filled from address",
            value: addressData.longitude,
            onChange: (e) => handleAddressChange('longitude', e.target.value),
            xs: 6,
            helperText: "Auto-filled",
        },
    ];

    const handleAddressChange = (field, value) => {
        setAddressData({
            ...addressData,
            [field]: value,
        });
    };

    useEffect(() => {
        setServiceLineName(serviceLineToUpdate?.serviceLineName);
        setOriginalServiceLineName(serviceLineToUpdate?.serviceLineName);
        setEmails(serviceLineToUpdate?.emailIds || []);
        setOriginalEmails(serviceLineToUpdate?.emailIds || []);
        setHomeAddress(serviceLineToUpdate?.address?.formattedAddress);
        setOriginalHomeAddress(serviceLineToUpdate?.address?.formattedAddress);
        setNotes(serviceLineToUpdate?.serviceLineNotes || '');
        setOriginalNotes(serviceLineToUpdate?.serviceLineNotes || '');
        const mt = typeof serviceLineToUpdate?.mobileTerminal === 'boolean'
            ? serviceLineToUpdate.mobileTerminal
            : (serviceLineToUpdate?.mobileTerminal === 'true' || serviceLineToUpdate?.mobileTerminal === 1 || serviceLineToUpdate?.mobileTerminal === '1')
                ? true
                : (serviceLineToUpdate?.mobileTerminal === 'false' || serviceLineToUpdate?.mobileTerminal === 0 || serviceLineToUpdate?.mobileTerminal === '0')
                    ? false
                    : true;
        setMobileTerminal(mt);
        setOriginalMobileTerminal(mt);

        if(serviceLineToUpdate?.userTerminalDetails && serviceLineToUpdate?.userTerminalDetails?.length > 0){
            getSitesForTerminal({terminalId: "ut" + serviceLineToUpdate?.userTerminalDetails[0]?.userTerminalId})
         }
     
    }, [serviceLineToUpdate]);

    useEffect(()=>{
        if(_.isEmpty(siteForTerminal)) return;
        setSelectedSite(siteForTerminal && siteForTerminal?.length > 0 ? siteForTerminal[0].site_id : "")
    },[siteForTerminal])

    const handleEditToggle = (type) => {
        if (type === 'serviceLine') {
            setIsEditingServiceLine(!isEditingServiceLine);
        } else if (type === 'homeAddress') {

            setAddressData({
                formattedAddress: serviceLineToUpdate?.address?.formattedAddress || '',
                addressLines: serviceLineToUpdate?.address?.addressLines || [],
                regionCode: serviceLineToUpdate?.address?.regionCode || '',
                administrativeAreaCode: serviceLineToUpdate?.address?.administrativeAreaCode || '',
                latitude: serviceLineToUpdate?.address?.latitude || '',
                longitude: serviceLineToUpdate?.address?.longitude || ''
            });
            setAddressSearchInput('');
            setAddressSuggestions([]);
            setMobileTerminal(originalMobileTerminal);
            setDialogOpen(true);
        }
    };

    const handleCancelEdit = (type) => {
        if (type === 'serviceLine') {
            setServiceLineName(originalServiceLineName);
            setIsEditingServiceLine(false);
        } else if (type === 'homeAddress') {
            setHomeAddress(originalHomeAddress);
            setIsEditingHomeAddress(false);
        }
    };

    const handleDeleteEmail = (emailToDelete) => {
        setEmails((prev) => prev.filter((email: any) => email?.email !== emailToDelete.email));
    };

    const handleAddEmail = (e) => {
        if (e.key === 'Enter' && emailInput) {
            setEmails([...emails, { name: emailInput.split('@')[0].replace('.', ' ').replace(/\b\w/g, char => char.toUpperCase()), email: emailInput }]);
            // setEmails([...emails, { email: emailInput, name: '' }]);
            setEmailInput('');
        }
    };

    const handleSave = async () => {
        const updatedAddress = {
            address_reference_id: serviceLineToUpdate?.address?.addressReferenceId,
            formatted_address: addressData.formattedAddress,
            address_lines: addressData.addressLines,
            region_code: addressData.regionCode,
            administrative_area_code: addressData.administrativeAreaCode,
            latitude: addressData.latitude,
            longitude: addressData.longitude
        };

        let updatePayload: any = {

        };

        if (serviceLineName !== originalServiceLineName) {
            updatePayload.serviceLineName = serviceLineName;
        }
        if (dialogOpen) {
            updatePayload.address = updatedAddress;
        }
        if (JSON.stringify(emails) !== JSON.stringify(originalEmails)) {
            updatePayload.emailIds = emails;
        }
        if (notes !== originalNotes) {
            updatePayload.notes = notes;
        }
        if (mobileTerminal !== originalMobileTerminal) {
            updatePayload.mobileTerminal = mobileTerminal;
        }

        updatePayload.organizationId = serviceLineToUpdate?.accountDpId;
        updatePayload.serviceLineNumber = serviceLineToUpdate?.serviceLineNumber;
        updatePayload.accountNumber = serviceLineToUpdate?.accountNumber;

        try {
            updateServiceLineDetails(updatePayload)

        } catch (e) {
            setIsEditingHomeAddress(false);
            setDialogOpen(false)
        }
    };

    // Debounced typeahead fetch for the Formatted Address Autocomplete
    useEffect(() => {
        const query = addressSearchInput?.trim() || '';
        if (query.length < 3) {
            setAddressSuggestions([]);
            setIsFetchingSuggestions(false);
            return;
        }

        let cancelled = false;
        setIsFetchingSuggestions(true);
        const timer = setTimeout(async () => {
            try {
                const res: any = await geocodeServiceAddress({ address: query });
                if (cancelled) return;
                if (res?.success && Array.isArray(res?.data?.results)) {
                    setAddressSuggestions(res.data.results);
                } else {
                    setAddressSuggestions([]);
                    if (res && res.success === false && res?.message) {
                        toast.error(res.message, { position: toast.POSITION.BOTTOM_LEFT });
                    }
                }
            } catch (e: any) {
                if (cancelled) return;
                setAddressSuggestions([]);
                toast.error(e?.response?.data?.message || e?.message || 'Failed to fetch address suggestions', {
                    position: toast.POSITION.BOTTOM_LEFT
                });
            } finally {
                if (!cancelled) setIsFetchingSuggestions(false);
            }
        }, 300);

        return () => {
            cancelled = true;
            clearTimeout(timer);
        };
    }, [addressSearchInput]);

    const handleSuggestionSelect = (suggestion: any) => {
        if (!suggestion) {
            setAddressData({
                administrativeAreaCode: '',
                regionCode: '',
                formattedAddress: '',
                addressLines: [],
                latitude: '',
                longitude: ''
            });
            return;
        }
        setAddressData({
            formattedAddress: suggestion.formattedAddress || '',
            addressLines: suggestion.addressLines || [],
            regionCode: suggestion.regionCode || '',
            administrativeAreaCode: suggestion.administrativeAreaCode || '',
            latitude: String(suggestion.latitude || ''),
            longitude: String(suggestion.longitude || '')
        });
    };

    useEffect(() => {
        if (!_.isEmpty(updateSLDetails)) {
            setOriginalServiceLineName(serviceLineName);
            setOriginalHomeAddress(homeAddress);
            setOriginalEmails(emails);
            setOriginalNotes(notes);
            setOriginalMobileTerminal(mobileTerminal);
            setIsEditingServiceLine(false);
            setIsEditingHomeAddress(false);
            setDialogOpen(false)
            changeSLName(serviceLineName)
            dispatch({ type: ACTION_TYPES.UPDATE_SERVICE_LINE_DETAILS, payload: {} })
            toast.success(`Service Line ${serviceLineName} updated successfully.`, {
                position: toast.POSITION.BOTTOM_LEFT,
            })
        }
        else {
            setIsEditingHomeAddress(false);
            setDialogOpen(false)
        }
    }, [updateSLDetails])

        useEffect(() => {
            setLoader( starlinkAdmin.addingSiteToServiceLine)
        }, [  starlinkAdmin.addingSiteToServiceLine ])


     useEffect(() => {
        if (_.isEmpty(getVesselsListing)) return;
        let locations: any[] = [];
        if (_.isArray(filteredVessels) && filteredVessels.length > 0) {
            locations = filteredVessels;
        } else {
            const { k4Ids = '' } = getDecodeURI(location?.search);
            const k4IdsFromUrl = strToK4List(k4Ids);
            if (_.isArray(k4IdsFromUrl) && k4IdsFromUrl.length) {
                locations = k4IdsFromUrl;
            } else if (_.isArray(getVesselsListing.locations)) {
                locations = getVesselsListing.locations;
            }
        }
        const data = locations.map(site => ({
            id: site.id,
            name: site['vessel-name'],
        }))

        if (_.isEqual(data, sites)) {
            return;
        } else {
            setSites(data);
        }
    }, [getVesselsListing, filteredVessels]);
   
    useEffect(()=>{
        if (_.isEmpty(sites)) return;
        getAllSitesWithDevices({sites:sites})

    },[sites])
  
    const uniqueSites = Array.from(
        new Map(
          (sitesWithDevices || []).map((item) => [
            item.site_id,
            { site_id: item.site_id, site_name: item.site_name },
          ])
        ).values()
      );
      
      const devicesForSelectedSite = (sitesWithDevices || []).filter(
        (item) => item.site_id === selectedSite
      );
  
    const handleSiteChange = (val) => {
        setShowCheck(true)  
      setSelectedSite(val);
      setSelectedDevice(""); 
    };
  
    const handleDeviceChange = (event) => {
      setSelectedDevice(event.target.value);
    };

    const handleSiteUpdate = async() =>{
        let params = {
            siteId: selectedSite,
            deviceId: devicesForSelectedSite[0].device_id,
            serviceLineNumber: serviceLineToUpdate?.serviceLineNumber,
            userTerminalId: serviceLineToUpdate?.userTerminalDetails && serviceLineToUpdate?.userTerminalDetails.length > 0 ? "ut"+serviceLineToUpdate?.userTerminalDetails[0]?.userTerminalId : ""
        }
        await addSiteToServiceLineApi(params)
    }

     useEffect(() => {
            if (!_.isEmpty(addSiteToServiceLine)) {
                toast.success(`Site Updated Successfully .`, {
                    position: toast.POSITION.BOTTOM_LEFT,
                })
                setShowCheck(false)
                
                dispatch({ type: ACTION_TYPES.ADD_SITE_TO_SERVICE_LINE, payload: {} })
    
            }
    
        }, [addSiteToServiceLine])


return (
        <div className="serviceLineDetails-container">
            <Box className="starlink-serviceline-details-container">
                <Box className="starlink-serviceline-details-row">
                    <Box className="starlink-serviceline-details-heading">Account Number:</Box>
                    <Box className="starlink-serviceline-details-value">{serviceLineToUpdate?.accountNumber}</Box>
                </Box>

                <Box className="starlink-serviceline-details-row">
                    <Box className="starlink-serviceline-details-heading">Service Line Number:</Box>
                    <Box className="starlink-serviceline-details-value">{serviceLineToUpdate?.serviceLineNumber}</Box>
                </Box>

                <Box className="starlink-serviceline-details-row">
                    <Box className="starlink-serviceline-details-heading">Service Line Name:</Box>
                    {isEditingServiceLine ? (
                        <>
                            <TextField
                                size="small"
                                value={serviceLineName}
                                onChange={(e) => setServiceLineName(e.target.value)}
                                className="starlink-serviceline-details-value"
                            />
                            <Tooltip title="Save">
                                <span>
                                    <IconButton
                                        //   color="primary"
                                        onClick={handleSave}
                                        className="starlink-serviceline-details-save-button"
                                        disabled={serviceLineName === originalServiceLineName}
                                    >
                                        <CheckIcon />
                                    </IconButton>
                                </span>
                            </Tooltip>
                            <Tooltip title="Cancel">
                                <IconButton onClick={() => handleCancelEdit('serviceLine')} className="starlink-serviceline-details-cancel-button">
                                    <CloseIcon />
                                </IconButton>
                            </Tooltip>
                        </>
                    ) : (
                        <>
                            <Box className="starlink-serviceline-details-value">{serviceLineName}</Box>
                            <IconButton onClick={() => handleEditToggle('serviceLine')} className="starlink-serviceline-details-edit-button padding-left-right">
                                <EditIcon />
                            </IconButton>
                        </>
                    )}
                </Box>

                <Box className="starlink-serviceline-details-row">
                    <Box className="starlink-serviceline-details-heading">Home Address:</Box>
                    {isEditingHomeAddress ? (
                        <>
                            <TextField
                                size="small"
                                value={homeAddress}
                                onChange={(e) => setHomeAddress(e.target.value)}
                                className="starlink-serviceline-details-value"
                            />
                            <Tooltip title="Save">
                                <span>
                                    <IconButton
                                        onClick={handleSave}
                                        className="starlink-serviceline-details-save-button"
                                        disabled={homeAddress === originalHomeAddress}
                                    >
                                        <CheckIcon />
                                    </IconButton>
                                </span>
                            </Tooltip>
                            <Tooltip title="Cancel">
                                <IconButton onClick={() => handleCancelEdit('homeAddress')} className="starlink-serviceline-details-cancel-button ">
                                    <CloseIcon />
                                </IconButton>
                            </Tooltip>
                        </>
                    ) : (
                        <>
                            <Box className="starlink-serviceline-details-value">{homeAddress}</Box>
                            <IconButton onClick={() => handleEditToggle('homeAddress')} className="starlink-serviceline-details-edit-button padding-left-right">
                                <EditIcon />
                            </IconButton>
                        </>
                    )}
                </Box>

                <Box className="starlink-serviceline-details-row">
                    <Box className="starlink-serviceline-details-heading">Kit Serial:</Box>
                    <Box className="starlink-serviceline-details-value">{serviceLineToUpdate?.userTerminals}</Box>
                </Box>

                {/* <Box className="starlink-serviceline-details-row">
                    <Box className="starlink-serviceline-details-heading">Site: </Box>
                    <Box className="starlink-serviceline-details-value">

                    <FormControl>
                    <Autocomplete
                        options={uniqueSites}
                        getOptionLabel={(option:any) => option.site_name}
                        value={uniqueSites.find((site:any) => site.site_id === selectedSite) || null}
                        onChange={(event, newValue:any) => {
                            handleSiteChange(newValue ? newValue.site_id : null);
                        }}
                        renderInput={(params) => (
                            <TextField {...params}  variant="outlined" size="small" />
                        )}
                        sx={{ minWidth: 200 }} 
    />
                                
                            </FormControl>
                            {siteForTerminal && siteForTerminal?.length > 0  && selectedSite !==  siteForTerminal[0].site_id && showCheck ?
                             <>
                             <Tooltip title="Save">
                                <span>
                                    <IconButton 
                                        onClick={handleSiteUpdate}
                                        className="starlink-serviceline-details-save-button"
                                    >
                                        <CheckIcon />
                                    </IconButton>
                                </span>
                            </Tooltip>
                            <Tooltip title="Cancel">
                                <IconButton onClick={() => setSelectedSite(siteForTerminal && siteForTerminal?.length > 0 && siteForTerminal[0].site_id)} className="starlink-serviceline-details-cancel-button ">
                                    <CloseIcon />
                                </IconButton>
                            </Tooltip>
                            </> : <></>}
                    </Box>
                </Box> */}

                {selectedSite &&
                <Box className="starlink-serviceline-details-row">
                    <Box className="starlink-serviceline-details-heading">Device: </Box>
                    <Box className="starlink-serviceline-details-value">
                        {selectedSite && devicesForSelectedSite.length === 1 ? (
                            <Typography variant="body1">
                             {devicesForSelectedSite[0].device_id}
                            </Typography>
                        ) : (
                            <FormControl fullWidth margin="normal">
                                  <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label=""
                                    value={selectedDevice}
                                    onChange={handleDeviceChange}
                                    size="small"
                                    style={{minWidth:"200px"}}
                                >
                                {devicesForSelectedSite.map((item) => (
                                <MenuItem key={item.device_id} value={item.device_id}>
                                    {item.device_id}
                                </MenuItem>
                                ))}
                            </Select>
                            </FormControl>
                        )}
                    </Box>
                </Box> }

                {serviceLineToUpdate?.isCustomPlan ?
                    <>
                        <Box className="serviceLineDetails-divider-margin">
                            <Divider />
                        </Box>
                        <Box className="starlink-serviceline-details-row">
                            <Box className="starlink-serviceline-details-heading">Current Plan:</Box>
                            <Box className="starlink-serviceline-details-value">{serviceLineToUpdate?.servicePlan}</Box>
                        </Box>
                    </> :
                    <>
                        <Box className="starlink-serviceline-details-row">
                            <Box className="starlink-serviceline-details-heading">Current Plan:</Box>
                            <Box className="starlink-serviceline-details-value">{serviceLineToUpdate?.servicePlan}</Box>
                        </Box>

                        <Box className="serviceLineDetails-divider-margin">
                            <Divider />
                        </Box>
                    </>}


            </Box>

            <Typography fontWeight={"550"} component="div" >Email Ids:</Typography>
            <Grid item xs={12}>
                <Box>
                    <Paper
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            padding: '8px',
                            borderRadius: '10px',
                            border: '1px solid #c2d3eb',
                            boxShadow: 'none',
                        }}
                    >
                        {emails.map((email, index) => (
                            <Chip
                                key={index}
                                label={email?.email}
                                onDelete={() => handleDeleteEmail(email)}
                                sx={{ margin: '4px' }}
                            />
                        ))}
                        <TextField
                            size="small"
                            fullWidth
                            variant="standard"
                            error={!!error}
                            placeholder="Press Enter to add email"
                            helperText={error}
                            value={emailInput}
                            onChange={(e) => setEmailInput(e.target.value)}
                            onKeyDown={handleAddEmail}
                            InputProps={{
                                disableUnderline: true,
                                style: {
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    padding: '0 4px',
                                },
                            }}
                            sx={{
                                width: 'auto',
                                flexGrow: 1,
                                minWidth: '120px',
                                '& .MuiInputBase-root': {
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                },
                                '& .MuiInputBase-input': {
                                    padding: '8px 4px',
                                    flex: 1,
                                },
                            }}
                        />
                    </Paper>
                </Box>
                <Typography variant="caption" color="textSecondary" sx={{ marginTop: '4px', marginLeft: '8px' }}>
                    Quota Kontrol Notifications shall be sent to this email.
                </Typography>

                {JSON.stringify(emails) !== JSON.stringify(originalEmails) && (
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
                        <Button variant="contained" onClick={handleSave}> Save Email Ids </Button>
                    </Box>
                )}
            </Grid>

            <Box sx={{ mt: 2, mb: 2 }}>
                <Typography fontWeight={"550"} component="div" >Deployment:</Typography>
                <TextField
                    fullWidth
                    multiline
                    rows={1}
                    variant="outlined"
                    placeholder=""
                    value={notes}
                    inputProps={{ maxLength: 250 }}
                    helperText={`${notes?.length || 0}/250 characters`}
                    onChange={(e) => setNotes(e.target.value)}
                />

                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
                    <Button disabled={notes === originalNotes} variant="contained" onClick={handleSave}>Save</Button>
                </Box>

            </Box>


            <Dialog
                PaperProps={{
                    sx: {
                        width: '500px',
                        maxWidth: '500px',
                    },
                }}
                open={dialogOpen}
                onClose={() => {
                    setDialogOpen(false);
                    setAddressSearchInput('');
                    setAddressSuggestions([]);
                }}
            >
                <DialogTitle>Enter Address</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Typography variant="subtitle1">Formatted Address</Typography>
                            <Autocomplete
                                fullWidth
                                options={addressSuggestions}
                                loading={isFetchingSuggestions}
                                filterOptions={(x) => x}
                                getOptionLabel={(option: any) =>
                                    typeof option === 'string' ? option : (option?.formattedAddress || '')
                                }
                                isOptionEqualToValue={(option: any, value: any) =>
                                    option?.placeId === value?.placeId
                                }
                                value={addressData.formattedAddress ? addressData : null}
                                inputValue={addressSearchInput || addressData.formattedAddress || ''}
                                onInputChange={(_event, newValue, reason) => {
                                    if (reason === 'input') {
                                        setAddressSearchInput(newValue);
                                    } else if (reason === 'clear') {
                                        setAddressSearchInput('');
                                        handleSuggestionSelect(null);
                                    }
                                }}
                                onChange={(_event, newValue: any) => {
                                    handleSuggestionSelect(newValue);
                                    setAddressSearchInput(newValue?.formattedAddress || '');
                                }}
                                noOptionsText={
                                    (addressSearchInput?.trim().length || 0) < 3
                                        ? 'Type at least 3 characters to search'
                                        : (isFetchingSuggestions ? 'Searching...' : 'No matching addresses')
                                }
                                renderOption={(props, option: any) => (
                                    <li {...props} key={option.placeId}>{option.formattedAddress}</li>
                                )}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Start typing address..."
                                    />
                                )}
                            />
                        </Grid>
                        {formFields.map((field: any, index) => (
                            <Grid item xs={field.xs} key={index}>
                                <Typography variant="subtitle1">{field.label}</Typography>
                                <TextField
                                    fullWidth
                                    placeholder={field.placeholder}
                                    value={field.value}
                                    onChange={field.onChange}
                                    disabled={!!field.disabled}
                                    helperText={field.helperText}
                                />
                            </Grid>
                        ))}
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={!mobileTerminal}
                                        onChange={() => setMobileTerminal(!mobileTerminal)}
                                        size="small"
                                    />
                                }
                                label="Use Street Address for Map Location"
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => {
                        setDialogOpen(false);
                        setAddressSearchInput('');
                        setAddressSuggestions([]);
                    }} variant="outlined">
                        Cancel
                    </Button>
                    <Button
                        onClick={handleSave}
                        disabled={
                            addressData.formattedAddress === '' ||
                            addressData.administrativeAreaCode === '' ||
                            addressData.regionCode === '' ||
                            addressData.latitude === '' ||
                            addressData.longitude === ''
                        }
                        variant="contained"
                        color="primary"
                    >
                        Add
                    </Button>
                </DialogActions>
            </Dialog>
        </div>


    );
};

const mapStateToProps = (state) => ({
    loading: state.starlinkAdmin.subcribingServiceLine,
    starlinkAdmin: state.starlinkAdmin,
    updateSLDetails: state.starlinkAdmin.updateServiceLineDetail,
    authReducer: state.authReducer,
    getVesselsListing: state.authReducer?.getVesselsListing,
    filteredVessels: state.authReducer?.filteredVessels,
    usersList: state.authReducer.usersList,
    sitesWithDevices: state.starlinkAdmin.sitesWithDevices,
    siteForTerminal: state.starlinkAdmin.siteForTerminal,
    addSiteToServiceLine: state.starlinkAdmin.addSiteToServiceLine
});

export default withRouter(
    connect(mapStateToProps, {
        updateServiceLineDetails,
         getAllSitesWithDevices,
         getSitesForTerminal,
         addSiteToServiceLineApi,
         geocodeServiceAddress
        })(ServiceLineDetails)
);

